import { createContext, ReactNode, useContext } from "react";

type TabularMenuContextType = {
  tabs: {
    label: string | ReactNode;
    component: ReactNode;
    onClick?: () => void;
  }[];
  activeTabComponent: ReactNode;
  activeTabIndex: number;
  setActiveTabIndex: (index: number) => void;
};

export const TabularMenuContext = createContext<TabularMenuContextType>({
  tabs: [],
  activeTabComponent: null,
  activeTabIndex: 0,
  setActiveTabIndex: () => {},
});

export const useTabularMenuContext = () => useContext(TabularMenuContext);
